import axios from '../../app/axiosConfig';

export const getShopReq = async (shopKey) => {
  return axios.get(`/shops/${shopKey}`);
};
